import GlobalStyles from "@mui/material/GlobalStyles";

export const RightDrawerWidth = "350px";

export enum AppGlobalClassKeys {
    borderAnts = "borderAnts",
    cellAlignTop = "cellAlignTop",
    centerChild = "centerChild",
    clickable = "clickable",
    containerRounded = "containerRounded",
    drawerFixedSizeList = "drawerFixedSizeList",
    filterDisabled = "filterDisabled",
    invisible = "invisible",
    lineHighlight = "lineHighlight",
    hideElement = "hideElement",
    hiddenIfEmpty = "hidden-if-empty",
    qlContentSection = "qlContentSection",
    textCenter = "textCenter",
    textLineBreak = "textLineBreak",
    textNoWrap = "textNoWrap",
    textRight = "textRight",
    thinScrollbar = "thinScrollbar",
    thinScrollbarOver = "thinScrollbarOver",
    truncateLine = "truncateLine",
    unorderedListFlat = "unorderedListFlat",
    paragraph = "paragraph"
}

export const AppGlobalStyles: React.FC = () => {

    return <GlobalStyles
        styles={
            (theme) => ({
                // Quando tocando somente um AUDIO, o css utilizado pelo chrome adicionar um MaxHeight muito grande.
                // Este hack deixa a barra de controles com o mesmo tamanho da barra quando tocando um video.
                // A tag vídeo precisa do atributo "paudioonly=true" para funcionar.
                "video[paudioonly='true']::-webkit-media-controls-enclosure": {
                    maxHeight: 32,
                    margin: 12,
                },

                "video[paudioonly='true']::-webkit-media-controls": {
                    paddingRight: "8px",
                    paddingLeft: "8px",
                },

                "html, input, textarea, a": {
                    ...theme.extended.font
                },
                "a": {
                    ...theme.extended.link.default
                },
                "a:visited": {
                    ...theme.extended.link.visited
                },
                "a:hover": {
                    ...theme.extended.link.hover
                },
                "a:focus": {
                    ...theme.extended.link.focus
                },
                ":focus": {
                    outlineColor: "transparent"
                },

                ".paragraph > p": {
                    marginTop: "0.2em",
                    marginBottom: "0.2em"
                },

                ".thinScrollbar": {
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                    "::-webkit-scrollbar": {
                        width: 8,
                        height: 8,
                    },
                    "::-webkit-scrollbar-track": {
                        backgroundColor: "lightgray",
                    },
                    "::-webkit-scrollbar-thumb": {
                        backgroundColor: "grey",
                        borderRadius: "50px",
                        border: "3px solid grey"
                    }
                },
                ".thinScrollbarOver": {
                    overflow: "auto",
                    paddingRight: theme.spacing(1),
                    "::-webkit-scrollbar": {
                        width: 8,
                        height: 8,
                    },
                    "::-webkit-scrollbar-thumb": {
                        backgroundColor: "transparent",
                        borderRadius: 0,
                        border: "none",
                    },
                    "::-webkit-scrollbar-track": {
                        backgroundColor: "transparent",
                    },
                    "&:hover::-webkit-scrollbar-thumb": {
                        backgroundColor: "grey",
                        borderRadius: "50px",
                        border: "3px solid grey"
                    },
                    "&:hover::-webkit-scrollbar-track": {
                        backgroundColor: "lightgray",
                    }
                },

                ".notificationWorkspace": {
                    color: theme.palette.common.black,
                    "& a": {
                        textDecoration: "underline",
                        color: theme.palette.info.light,
                        display: "inline-block",
                        lineHeight: 1.3
                    },
                    "& a:hover": {
                        textDecoration: "underline",
                        color: theme.palette.info.main,
                    },
                    "& blockquote": {
                        borderLeft: "4px solid",
                        borderLeftColor: theme.palette.muted.main,
                        margin: 0,
                        padding: "0.3em",
                    }
                },

                ".lineHighlight:hover": {
                    backgroundColor: theme.palette.paper.main
                },

                ".centerChild": {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                },

                ".clickable": {
                    cursor: "pointer",
                    "&.zoomIn": {
                        cursor: "zoom-in"
                    },
                    "&.zoomOut": {
                        cursor: "zoom-out"
                    },
                    "&.notAllowed": {
                        cursor: "not-allowed",
                    },
                },

                ".feedCarouselButton": {
                    height: "calc(100% - 70px) !important",
                    top: "0 !important",
                },

                ".disabled": {
                    pointerEvents: 'none',
                    color: theme.palette.muted.ligth,
                    "&:hover": {
                        color: "inherit",
                    }
                },

                ".drawerFixedSizeList": {
                    overflowY: "inherit",
                    padding: 0,
                },

                ".filterDisabled": {
                    "-webkit-filter": "grayscale(1)",
                },

                ".textCenter": {
                    textAlign: "center"
                },

                ".textRight": {
                    textAlign: "right"
                },

                ".textNoWrap": {
                    whiteSpace: "nowrap"
                },

                ".textLineBreak": {
                    whiteSpace: "pre-line"
                },

                ".cellAlignTop": {
                    verticalAlign: "top !important"
                },

                ".hideElement": {
                    display: "none !important"
                },

                ".invisible": {
                    visibility: "hidden"
                },

                ".containerRounded": {
                    backgroundColor: theme.palette.paper.light,
                    borderRadius: 8,
                    height: "100%",
                    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
                },

                "@keyframes marching-ants": {
                    "0%": {
                        backgroundPosition: "0 0, 30px 100%, 0 30px, 100% 0",
                    },
                    "100%": {
                        backgroundPosition: "30px 0, 0 100%, 0 0, 100% 30px"
                    }
                },
                ".borderAnts": {
                    backgroundImage: "linear-gradient(90deg, black 50%, transparent 50%), linear-gradient(90deg, black 50%, transparent 50%), linear-gradient(0, black 50%, transparent 50%), linear-gradient(0, black 50%, transparent 50%)",
                    backgroundRepeat: "repeat-x, repeat-x, repeat-y, repeat-y",
                    backgroundSize: "30px 2px, 30px 2px, 2px 30px, 2px 30px",
                    animation: "marching-ants 400ms infinite linear",
                },

                ".truncateLine": {
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                },

                "@media print": {
                    ".no-print": {
                        display: "none"
                    }
                },

                /**
                 * QuillJS
                 */
                ".qlContentSection": {
                    p: { margin: 0 },
                },
                ".ql-mention-list-container": {
                    zIndex: 10000
                },

                /**
                 * Remove o padding do último MprcContainer dentro de um CardContent, evitando disperdício de espaço.
                 */
                ".MprcContainer + .MprcContainer:last-child": {
                    paddingBottom: 0
                },

                /**
                 *
                 */
                ".hidden-if-empty:empty": {
                    display: "none"
                },

                /**
                 * Knowledge: visualização de resumo de um post do Twitter.
                 */
                ".twitter-post": {
                    "& a, a:visited": {
                        color: theme.palette.secondary.main,
                        textDecoration: "none"
                    },
                    "& a:hover": {
                        color: theme.palette.secondary.light,
                    },
                    "& .twitter-tweet": {
                        margin: 0,
                        padding: 0
                    },
                    "& .MuiGrid-item": {
                        padding: theme.spacing(1)
                    },
                },
                ".unorderedListFlat": {
                    listStylePosition: "inside",
                    margin: 0,
                    padding: 0
                },

                /***
                 * CardLightBox
                 */
                ".yarl__slide_image_cover": {
                    objectFit: "contain",
                    width: "100%",
                    height: "100%"
                },

                /***
                 * ReactPlayer
                 */
                "video::cue": {
                    bottom: "28px !important",
                    // fontSize: "18px !important",
                    fontFamily: "Arial, sans-serif !important",
                    backgroundCcolor: "rgba(0, 0, 0, 0.8) !important",
                    color: "white !important",
                    padding: "4px 8px !important",
                    borderRadius: "4px !important",
                    lineHeight: "1.4 !important",
                },

                "video::cue(.speaker)": {
                    color: "#ffeb3b!important",
                    fontWeight: "bold !important",
                },

                /* Posicionamento específico para o container de legendas */
                "video::-webkit-media-text-track-display": {
                    bottom: "28px!important",
                    top: "auto!important",
                },

                /* Para Firefox */
                "video::-moz-media-text-track-display": {
                    bottom: "28px!important",
                    top: "auto!important",
                },

                ".ragsearch": {
                    color: "#000",
                    lineHeight: "22px",
                    fontSize: "14px",
                    "p": {
                        marginBlockStart: ".5em",
                        marginBlockEnd: ".5em",
                    },
                    ".subjectMismatch": {
                        color: "red",
                        fontWeight: "bold"
                    }
                }

            })
        }
    />;
};
